<div class="recharge-battery clearfix">
  <div class="img-battery" [class.plugged]="plugged" [class.sufficient]="isSufficient">
    <div class="battery-bar" [ngStyle]="{'transform': 'scaleY(' + this.batteryPercent + ')'}"></div>
    <img class="img-battery-bg" src="{{assetsUrl}}assets/images/recharge-bg.svg" alt="Recharge">
    <img class="img-plug" src="{{assetsUrl}}assets/images/recharge-plug.svg" alt="Recharge">
  </div>
  <div class="battery-text">
    <h4 class="mb-0">
      <ng2-odometer [number]="availableCredits"></ng2-odometer>
    </h4>
    <p><span class="text-dull">{{textAvailable}}</span></p>
  </div>
  <div class="booster-text">
    <h4 class="mb-0">
      <ng2-odometer [number]="earnedCredits"></ng2-odometer>
    </h4>
    <p class="pl-4"><span class="text-dull">{{textEarned}} </span>
      <i class="icon-dull icon-help" ngbTooltip="{{textEarnedSub}}"></i></p>
  </div>
</div>
